let ipCache: string;

export async function getIpAddress(): Promise<string> {
  if (ipCache) return ipCache;

  try {
    const res = await fetch("https://api64.ipify.org?format=json");
    const data = await res.json();
    ipCache = data.ip;
    return ipCache;
  } catch (error) {
    console.error("Failed to fetch IP address:", error);
    ipCache = "Unknown";
    return ipCache;
  }
}
